<template>
  <div class="ws-state-file-item">
    <v-progress-circular
      v-if="loading"
      color="primary"
      indeterminate
    >{{percent}}</v-progress-circular>
    <template v-else>
      <component
        v-if="url"
        target="_blank"
        :href="url"
        :is="isLink ? 'a' : 'span'"
        class="ws-state-file-item__link"
        @click="$_onClick()"
      >{{$_getFileNameFromUrl(url)}}</component>
      <v-btn
        v-if="updatable"
        icon
        @click.stop="$_onRemoveClick()"
        class="ws-state-file-item__icon mr-3 textPrimary--text"
      >
        <v-icon>mdi-close-circle</v-icon>
      </v-btn>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    updatable: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    percent: {
      type: Number,
      default: 0
    },
    url: {
      type: String,
      default: null
    },
    isLink: {
      type: Boolean,
      default: true,
    },
    customFunction: {
      type: Function,
    }
  },
  methods: {
    $_onRemoveClick() {
      this.$emit("remove");
    },
    $_handleUploadProgress(progressEvent) {
      this.uploadPercent = Math.round(
        (progressEvent.loaded / progressEvent.total) * 100
      );
    },
    $_getFileNameFromUrl(url) {
      if (!url) {
        return null;
      }
      return decodeURIComponent(url)
        .split("?")[0]
        .split("/")
        .pop();
    },
    $_onClick() {
      if (this.isLink) return;
      if(this.customFunction) this.customFunction(this.url);
      else this.$emit('click');
    }
  }
};
</script>